type PlainObject = Record<string, unknown>;

const isPlain = (value: unknown): value is PlainObject =>
  typeof value === "object" && value !== null && !Array.isArray(value);

/** Mescla uma parte do `pt`: objetos se fundem (a tela vence chave a chave, também nas subpartes); função da tela recebe o padrão por baixo. */
function mergePart(defaults: unknown, own: unknown): unknown {
  if (own === undefined) return defaults;
  if (typeof own === "function") {
    return (options: unknown) => {
      const result = own(options);
      return isPlain(defaults) && isPlain(result) ? mergePart(defaults, result) : result;
    };
  }
  if (isPlain(defaults) && isPlain(own)) {
    const merged: PlainObject = { ...defaults };
    for (const [key, value] of Object.entries(own)) merged[key] = mergePart(defaults[key], value);
    return merged;
  }
  return own;
}

/**
 * Padrões do DS para o `pt` (pass-through) de um wrapper do Prime, com o `pt` da tela MESCLADO por parte: um `pt` parcial
 * (`{ firstPageButton: { className } }`) não apaga o `data-testid`/`aria-label` padrão da mesma parte. Um spread simples
 * (`{ ...padrão, ...pt }`) trocaria a parte inteira.
 */
export function mergePt<D extends object>(defaults: D, pt: object | undefined): D {
  return mergePart(defaults, pt) as D;
}
